// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_recordings_listQueryVariables = Exact<{
  layout: Scalars['String']['input'];
}>;


export type easyreels_user_recordings_listQuery = { __typename?: 'Query', me: { __typename?: 'Me', usedBytes: number, limitBytes: number }, recordings: { __typename?: 'RecordingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Recording', id: number, kind: RecordingKind, status: RecordingStatus, bytes: number, error: string, createdAt: { __typename?: 'Timestamp', formatted: string }, segments: { __typename?: 'SegmentsConnection', nodes: Array<{ __typename?: 'Segment', index: number, bytes: number, startMs: number, endMs: number, downloadURL?: string | null }> } }> } };


export function $easyreels_user_recordings_list(variables: easyreels_user_recordings_listQueryVariables, opts?: { revalidate?: boolean }): easyreels_user_recordings_listQuery {
	return $easyreels_gql_user_request(`query easyreels_user_recordings_list(\u0024layout: String!) {
  me {
    usedBytes
    limitBytes
  }
  recordings {
    totalCount
    nodes {
      id
      kind
      status
      bytes
      error
      createdAt {
        formatted(layout: \u0024layout)
      }
      segments {
        nodes {
          index
          bytes
          startMs
          endMs
          downloadURL
        }
      }
    }
  }
}`, variables, opts) as easyreels_user_recordings_listQuery
}

}
